import { createItemImageColumnDefinition } from '../../../items/items-table/columns/item-image';
import { createItemNameColumnDefinition } from '../../../items/items-table/columns/item-name';
import { createItemQuantityColumnDefinition } from '../../../items/items-table/columns/item-quantity';
import { createItemReturnReasonColumnDefinition } from '../../../items/items-table/columns/item-return-reason';
import { createItemTotalColumnDefinition } from '../../../items/items-table/columns/item-total';

const columns = [
  createItemNameColumnDefinition(),
  createItemImageColumnDefinition(),
  createItemQuantityColumnDefinition(),
  createItemTotalColumnDefinition(),
  createItemReturnReasonColumnDefinition(),
];

export default columns;
